var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"masonryElement",staticClass:"__grid--masonry",class:{ '__stretch-first': _vm.stretchFirst },style:({ '--grid-gap': _vm.gridGap, '--col-width': _vm.colWidth })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }